import { render, staticRenderFns } from "./SavePieceForm.vue?vue&type=template&id=39de5674&"
import script from "./SavePieceForm.vue?vue&type=script&lang=js&"
export * from "./SavePieceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports